(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-cart-root]');
    if (!root) return;

    // --- Qty stepper ---
    root.addEventListener('click', async (e) => {
      const qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        e.preventDefault();
        const line = parseInt(qtyBtn.getAttribute('data-line'), 10);
        const delta = parseInt(qtyBtn.getAttribute('data-delta'), 10);
        const row = qtyBtn.closest('[data-line-key]');
        const current = parseInt(row.querySelector('.main-cart__qty-value').textContent, 10);
        const next = Math.max(0, current + delta);
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line, quantity: next }),
          });
          window.location.reload();
        } catch (err) {
          console.error('Cart change failed', err);
        }
        return;
      }
      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        const line = parseInt(removeBtn.getAttribute('data-line'), 10);
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line, quantity: 0 }),
          });
          window.location.reload();
        } catch (err) {
          console.error('Cart remove failed', err);
        }
      }
    });

    // --- Note auto-save on blur ---
    const noteEl = root.querySelector('[data-cart-note]');
    const noteFeedback = root.querySelector('[data-cart-note-feedback]');
    if (noteEl) {
      let lastSaved = noteEl.value;
      noteEl.addEventListener('blur', async () => {
        if (noteEl.value === lastSaved) return;
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: noteEl.value }),
          });
          lastSaved = noteEl.value;
          if (noteFeedback) {
            noteFeedback.textContent = noteFeedback.getAttribute('data-saved-label') || 'Note saved.';
            noteFeedback.setAttribute('data-visible', 'true');
            setTimeout(() => noteFeedback.setAttribute('data-visible', 'false'), 2000);
          }
        } catch (err) {
          console.error('Note save failed', err);
        }
      });
    }

    // --- Discount apply ---
    // Uses Shopify's /discount/<code>?redirect=/cart URL pattern: applies the
    // code and lands the user back on the cart page with the discount active.
    const discountForm = root.querySelector('[data-discount-form]');
    if (discountForm) {
      discountForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const input = discountForm.querySelector('input[name="discount"]');
        if (!input) return;
        const code = input.value.trim();
        if (!code) return;
        window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=/cart');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-header]');
    if (header) {
      const update = () => {
        const scrolled = window.scrollY > 24;
        header.setAttribute('data-scrolled', scrolled ? 'true' : 'false');
      };
      update();
      window.addEventListener('scroll', update, { passive: true });
    }

    const openBtn = document.querySelector('[data-mobile-menu-open]');
    const closeBtn = document.querySelector('[data-mobile-menu-close]');
    const menu = document.querySelector('[data-mobile-menu]');

    if (openBtn && menu) {
      openBtn.addEventListener('click', () => {
        menu.hidden = false;
        openBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      });
    }
    if (closeBtn && menu) {
      closeBtn.addEventListener('click', () => {
        menu.hidden = true;
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    }

    // Close mobile menu when a link is clicked.
    document.querySelectorAll('.mobile-menu__link').forEach((link) => {
      link.addEventListener('click', () => {
        if (menu) menu.hidden = true;
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });

    // Theme toggle.
    document.querySelectorAll('[data-theme-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const current = document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
        const next = current === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', next);
        try {
          localStorage.setItem('cham-theme', next);
        } catch (e) {}
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const heroes = Array.from(document.querySelectorAll('.home-hero'));

    heroes.forEach((root) => {
      const slides = Array.from(root.querySelectorAll('.home-hero__image'));
      if (slides.length === 0) return;

      const rotationMs = parseInt(root.dataset.rotationMs, 10) || 6000;
      const fadeMs = parseInt(root.dataset.fadeMs, 10) || 800;

      slides.forEach((s) => s.style.setProperty('--hero-fade-ms', fadeMs + 'ms'));

      // Mobile breakpoint matches the CSS (max-width: 767px = mobile, otherwise desktop).
      const mobileMQ = window.matchMedia('(max-width: 767px)');

      // Read both desktop and mobile zoom ranges; pick per current viewport.
      const cs = window.getComputedStyle(root);
      function readZoomRange() {
        const isMobile = mobileMQ.matches;
        const from = parseFloat(cs.getPropertyValue(isMobile ? '--kb-zoom-from-m' : '--kb-zoom-from')) || 1.0;
        const to = parseFloat(cs.getPropertyValue(isMobile ? '--kb-zoom-to-m' : '--kb-zoom-to')) || 1.06;
        return { from, to, isMobile };
      }

      let { from: zoomFrom, to: zoomTo, isMobile } = readZoomRange();

      const motionOffDesktop = root.classList.contains('home-hero--no-motion');
      const motionOffMobile = root.classList.contains('home-hero--no-motion-mobile');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function isMotionOff() {
        if (reducedMotion) return true;
        const m = mobileMQ.matches;
        if (m && motionOffMobile) return true;
        if (!m && motionOffDesktop) return true;
        if (Math.abs(zoomTo - zoomFrom) < 0.001) return true;
        return false;
      }

      // ===== Static (no-motion) mode =====
      if (isMotionOff()) {
        slides.forEach((s, i) => {
          s.style.transform = 'scale(1.02)';
          if (i === 0) s.classList.add('is-active');
        });
        if (slides.length <= 1) return;

        let current = 0;
        const tick = () => {
          const next = (current + 1) % slides.length;
          slides[current].classList.remove('is-active');
          slides[next].classList.add('is-active');
          current = next;
        };
        let t = window.setInterval(tick, rotationMs);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            window.clearInterval(t);
            t = null;
          } else if (t === null) {
            t = window.setInterval(tick, rotationMs);
          }
        });
        return;
      }

      // ===== Continuous zoom across slides =====
      let current = 0;
      let zoom = zoomFrom;
      let direction = 1;
      let lastTs = null;
      let rafId = null;
      let timer = null;

      slides.forEach((s, i) => {
        s.style.transform = 'scale(' + zoomFrom + ')';
        if (i === 0) s.classList.add('is-active');
      });

      function applyTransformToAll() {
        const t = 'scale(' + zoom.toFixed(4) + ')';
        for (let i = 0; i < slides.length; i++) {
          slides[i].style.transform = t;
        }
      }

      function frame(ts) {
        if (lastTs === null) lastTs = ts;
        const dt = ts - lastTs;
        lastTs = ts;

        const range = zoomTo - zoomFrom;
        const speed = range / rotationMs;
        zoom += direction * speed * dt;

        if (zoom > zoomTo) zoom = zoomTo;
        if (zoom < zoomFrom) zoom = zoomFrom;

        applyTransformToAll();
        rafId = window.requestAnimationFrame(frame);
      }

      function showNext() {
        const next = (current + 1) % slides.length;
        if (next === current) return;
        slides[current].classList.remove('is-active');
        slides[next].classList.add('is-active');
        direction *= -1;
        current = next;
      }

      function startLoop() {
        if (rafId === null) {
          lastTs = null;
          rafId = window.requestAnimationFrame(frame);
        }
        if (timer === null && slides.length > 1) {
          timer = window.setInterval(showNext, rotationMs);
        }
      }

      function stopLoop() {
        if (rafId !== null) {
          window.cancelAnimationFrame(rafId);
          rafId = null;
        }
        if (timer !== null) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      // Re-read zoom range when viewport crosses the mobile/desktop boundary.
      function onViewportChange() {
        const next = readZoomRange();
        zoomFrom = next.from;
        zoomTo = next.to;
        // Clamp current zoom into the new range to avoid a visible jump.
        if (zoom > zoomTo) zoom = zoomTo;
        if (zoom < zoomFrom) zoom = zoomFrom;
      }
      if (typeof mobileMQ.addEventListener === 'function') {
        mobileMQ.addEventListener('change', onViewportChange);
      } else if (typeof mobileMQ.addListener === 'function') {
        mobileMQ.addListener(onViewportChange);
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopLoop();
        else startLoop();
      });

      startLoop();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-manifesto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-manifesto-video]').forEach(function (v) {
      v.removeAttribute('autoplay');
      try { v.pause(); } catch (e) {}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fireNewsletterConfetti() {
      var target = document.querySelector('[data-newsletter-success]');
      if (!target || target.dataset.confettiFired === '1') return;
      target.dataset.confettiFired = '1';

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) return;

      var canvas = document.createElement('canvas');
      canvas.className = 'home-newsletter__confetti-canvas';
      canvas.setAttribute('aria-hidden', 'true');
      document.body.appendChild(canvas);

      var ctx = canvas.getContext('2d');
      var dpr = window.devicePixelRatio || 1;

      function size() {
        canvas.width = window.innerWidth * dpr;
        canvas.height = window.innerHeight * dpr;
        canvas.style.width = window.innerWidth + 'px';
        canvas.style.height = window.innerHeight + 'px';
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      size();
      window.addEventListener('resize', size);

      var root = getComputedStyle(document.documentElement);
      function token(name, fallback) {
        var v = root.getPropertyValue(name).trim();
        return v || fallback;
      }
      var colors = [
        token('--primary', '#333333'),
        token('--primary-glow', '#555555'),
        token('--foreground', '#222222'),
        '#e5e5e5',
        '#999999'
      ];

      var rect = target.getBoundingClientRect();
      var originX = rect.left + rect.width / 2;
      var originY = rect.top + rect.height / 3;

      var particles = [];
      var count = 160;
      for (var i = 0; i < count; i++) {
        var angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.1;
        var speed = 6 + Math.random() * 11;
        particles.push({
          x: originX,
          y: originY,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          size: 4 + Math.random() * 7,
          color: colors[(Math.random() * colors.length) | 0],
          rot: Math.random() * Math.PI * 2,
          vr: (Math.random() - 0.5) * 0.35,
          life: 1,
          decay: 0.006 + Math.random() * 0.006
        });
      }

      function tick() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        var alive = false;
        for (var j = 0; j < particles.length; j++) {
          var p = particles[j];
          if (p.life <= 0) continue;
          alive = true;
          p.vy += 0.22;
          p.vx *= 0.992;
          p.x += p.vx;
          p.y += p.vy;
          p.rot += p.vr;
          p.life -= p.decay;
          ctx.save();
          ctx.globalAlpha = Math.max(p.life, 0);
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.45);
          ctx.restore();
        }
        if (alive) {
          requestAnimationFrame(tick);
        } else {
          window.removeEventListener('resize', size);
          canvas.remove();
        }
      }
      requestAnimationFrame(tick);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fireNewsletterConfetti);
    } else {
      fireNewsletterConfetti();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-collection-root]').forEach((root) => {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      const filters = root.querySelectorAll('[data-filter]');
      const items = root.querySelectorAll('[data-collection-item]');
      const counter = root.querySelector('[data-collection-count]');
      if (!filters.length || !items.length) return;

      const singular = counter ? counter.getAttribute('data-singular') || 'item' : 'item';
      const plural = counter ? counter.getAttribute('data-plural') || 'items' : 'items';

      function applyFilter(value) {
        let visible = 0;
        items.forEach((item) => {
          // Each item carries a comma-separated list of categories it belongs to,
          // already lowercased server-side. A product matches a filter if the
          // filter value appears as one of those comma-separated entries.
          const catsAttr = item.getAttribute('data-categories') || '';
          const cats = catsAttr
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean);
          const match = value === 'all' || cats.indexOf(value) !== -1;
          if (match) {
            item.removeAttribute('data-hidden');
            visible += 1;
          } else {
            item.setAttribute('data-hidden', 'true');
          }
        });
        if (counter) {
          counter.textContent = visible + ' ' + (visible === 1 ? singular : plural);
        }
      }

      filters.forEach((btn) => {
        btn.addEventListener('click', () => {
          const value = btn.getAttribute('data-filter-value');
          filters.forEach((b) => {
            const isActive = b === btn;
            b.classList.toggle('is-active', isActive);
            b.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          applyFilter(value);
        });
      });
      const sortSelect = root.querySelector('[data-collection-sort]');
      if (sortSelect) {
        sortSelect.addEventListener('change', () => {
          const form = sortSelect.closest('form');
          if (form) form.submit();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var section = document.currentScript.closest('[data-product-section]');
    if (!section) {
      var all = document.querySelectorAll('[data-product-section]');
      section = all[all.length - 1];
    }
    if (!section) return;

    var form        = section.querySelector('[data-product-form]');
    var stickyBar   = section.querySelector('[data-sticky-bar]');
    var header      = section.querySelector('[data-atc]');
    var description = section.querySelector('[data-description]');
    var seeMore     = section.querySelector('[data-see-more]');
    var track       = section.querySelector('[data-gallery-track]');
    var progress    = section.querySelector('[data-gallery-progress]');

    function addToCart(btn, buyNow) {
      if (!form || btn.disabled) return;
      var fd = new FormData(form);
      btn.setAttribute('data-loading', 'true');
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error('Add to cart failed');
          return r.json();
        })
        .then(function () {
          if (buyNow) {
            window.location.assign('/checkout');
            return;
          }
          btn.removeAttribute('data-loading');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(function () {
          btn.removeAttribute('data-loading');
          form.submit();
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var trigger = e.submitter || section.querySelector('[data-atc]');
        addToCart(trigger, trigger.hasAttribute('data-buy-now'));
      });
    }
    var stickyAtc = section.querySelector('[data-atc-sticky]');
    if (stickyAtc) stickyAtc.addEventListener('click', function () { addToCart(stickyAtc); });

    if (description && seeMore) {
      if (window.matchMedia('(max-width: 1023px)').matches) description.classList.add('is-clamped');
      seeMore.addEventListener('click', function () {
        var clamped = description.classList.toggle('is-clamped');
        seeMore.setAttribute('aria-expanded', String(!clamped));
        seeMore.textContent = clamped ? (seeMore.dataset.more || 'See more') : (seeMore.dataset.less || 'See less');
      });
    }

    if (track && progress) {
      var updateProgress = function () {
        var max   = track.scrollWidth - track.clientWidth;
        var ratio = max > 0 ? track.scrollLeft / max : 0;
        var slides = track.children.length || 1;
        progress.style.width     = (100 / slides) + '%';
        progress.style.transform = 'translateX(' + (ratio * (slides - 1) * 100) + '%)';
      };
      track.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
    }

    if (stickyBar && header && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          stickyBar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { rootMargin: '-80px 0px 0px 0px', threshold: 0 });
      io.observe(header);
    }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-video-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-video-player]').forEach(function (player) {
      var video = player.querySelector('[data-video]');
      if (!video) return;
      var toggles = player.querySelectorAll('[data-video-toggle]');
      var muteBtn = player.querySelector('[data-video-mute]');

      function setPlaying() {
        player.setAttribute('data-playing', video.paused ? 'false' : 'true');
      }
      function setMuted() {
        player.setAttribute('data-muted', video.muted ? 'true' : 'false');
      }

      toggles.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (video.paused) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      });

      video.addEventListener('click', function () {
        if (video.paused) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });

      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.preventDefault();
          video.muted = !video.muted;
          setMuted();
        });
      }

      video.addEventListener('play', setPlaying);
      video.addEventListener('pause', setPlaying);

      setPlaying();
      setMuted();

      // Optional autoplay (muted, respects reduced-motion preference).
      if (player.getAttribute('data-autoplay') === 'true' && !reduceMotion) {
        video.muted = true;
        setMuted();
        var tryPlay = function () { video.play().catch(function () {}); };
        if (video.readyState >= 2) {
          tryPlay();
        } else {
          video.addEventListener('canplay', tryPlay, { once: true });
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-key-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-feature-media]').forEach(function (media) {
      var poster = media.querySelector('[data-feature-poster]');
      var video = media.querySelector('video');
      if (!poster || !video) return;

      poster.addEventListener('click', function () {
        media.classList.add('is-playing');
        if (!video.hasAttribute('controls')) video.setAttribute('controls', '');
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      });

      video.addEventListener('pause', function () {
        if (video.currentTime === 0) media.classList.remove('is-playing');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-regimen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindCard(card) {
      if (card.dataset.regBound) return;
      card.dataset.regBound = 'true';

      var priceEl = card.querySelector('[data-reg-price]');
      var atc = card.querySelector('[data-reg-atc]');
      var label = atc ? atc.querySelector('[data-atc-label]') : null;

      card.querySelectorAll('input[name="id"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (priceEl && radio.dataset.price) priceEl.textContent = radio.dataset.price;
          if (atc) {
            var available = radio.dataset.available === 'true';
            atc.disabled = !available;
            if (label) label.textContent = available ? (atc.dataset.label || 'Add to bag') : (atc.dataset.sold || 'Sold out');
          }
        });
      });

      card.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!atc || atc.disabled) return;
        var fd = new FormData(card);
        atc.setAttribute('data-loading', 'true');
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json(); })
          .then(function () {
            atc.removeAttribute('data-loading');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:open'));
          })
          .catch(function () {
            atc.removeAttribute('data-loading');
            card.submit();
          });
      });
    }

    function init() {
      document.querySelectorAll('[data-reg-card]').forEach(bindCard);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-video-player]').forEach((player) => {
      if (player.dataset.bound === 'true') return;
      player.dataset.bound = 'true';
      const video = player.querySelector('[data-video]');
      if (!video) return;
      const toggles = player.querySelectorAll('[data-video-toggle]');
      const muteBtn = player.querySelector('[data-video-mute]');

      function setPlaying() {
        player.setAttribute('data-playing', video.paused ? 'false' : 'true');
      }
      function setMuted() {
        player.setAttribute('data-muted', video.muted ? 'true' : 'false');
      }

      toggles.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (video.paused) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      });

      video.addEventListener('click', () => {
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });

      if (muteBtn) {
        muteBtn.addEventListener('click', (e) => {
          e.preventDefault();
          video.muted = !video.muted;
          setMuted();
        });
      }

      video.addEventListener('play', setPlaying);
      video.addEventListener('pause', setPlaying);

      setPlaying();
      setMuted();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
